import { CURRENTS_APP_ID } from "./queries.js";
export class CurrentsGraphQLError extends Error {
    constructor(message) {
        super(message);
        this.name = "CurrentsGraphQLError";
    }
}
export async function currentsGraphQLFetch(opts) {
    const endpoint = opts.config.endpoint.trim();
    if (!endpoint)
        throw new CurrentsGraphQLError("Endpoint GraphQL mancante.");
    const idToken = await opts.config.getIdToken();
    if (!idToken)
        throw new CurrentsGraphQLError("Sessione scaduta.");
    const res = await fetch(endpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: idToken,
            "X-Vida-AppId": CURRENTS_APP_ID,
        },
        body: JSON.stringify({ query: opts.query, variables: opts.variables ?? {} }),
    });
    const text = await res.text();
    if (!res.ok)
        throw new CurrentsGraphQLError(`HTTP ${res.status}: ${text.slice(0, 400)}`);
    const json = JSON.parse(text);
    if (json.errors?.length) {
        throw new CurrentsGraphQLError(json.errors[0]?.message ?? "Errore GraphQL");
    }
    const data = json.data;
    if (!data || !(opts.resultKey in data)) {
        throw new CurrentsGraphQLError(`Campo mancante: ${opts.resultKey}`);
    }
    return data[opts.resultKey];
}
